const NS = 'SideNav';
const CLS = 'sideNav';

export class SideNav {
	constructor(element) {
		this.element = element;
		this.init();
	}

	init() {
		$(this.element).find('.sideNav-title-mb').on('click', (e) => {
			$(e.currentTarget).toggleClass('inactive, active');
			$(this.element).find('nav').toggleClass('inactive, active');
		});
	}
}
